import { NonNullableFormBuilder } from '@angular/forms';

export interface MedicalInformation {
  allergies: {
    nuts: boolean;
    soja: boolean;
    lactose: boolean;
    other?: string;
  };
  specialNeeds?: string;
}

export type Allergies = MedicalInformation['allergies'];
export type AllergyType = keyof Allergies;

export const createMedicalInformationFormGroup = (
  fb: NonNullableFormBuilder,
) => {
  return fb.group({
    allergies: fb.group({
      nuts: fb.control(false),
      soja: fb.control(false),
      lactose: fb.control(false),
      other: fb.control(''),
    }),
    specialNeeds: fb.control(''),
  });
};
